









import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin, AlertIndicationMixin } from "../../system/mixins";
import { IMultiSelectableAsynchronously, instanceOfIMultiSelectableConditionallyAsynchronously } from "../../system/selectors";

@Component({
  components: {
  },
})
export default class ConditionMultiDialogSelector extends Mixins(ModelEditableMixin, AlertIndicationMixin) {
  editingSource: any[];

  @Prop()
  dialog: IMultiSelectableAsynchronously<any>;

  @Prop({ default: false })
  isClearable: boolean;

  @Prop({ default: "選択" })
  labelOfSelect: string;

  @Prop({ default: "クリア" })
  labelOfClear: string;

  @Prop()
  format: (s: any[]) => string;

  @Prop({ default: false })
  disabled: boolean;

  @Prop({ default: "" })
  placeholder: string;

  @Prop()
  condition: any;

  get labelOfSelectedOption(): string {
    return !this.format
      ? (!this.editingSource ? "" : this.editingSource.join(","))
      : this.format(this.editingSource);
  }

  get isSelectable(): boolean {
    return !!this.dialog;
  }

  select(): void {
    if (instanceOfIMultiSelectableConditionallyAsynchronously<any, any>(this.dialog)) {
      this.dialog.selectOptionsConditionally(this.condition, this.editingSource)
        .then(o => {
          if (o !== undefined) {  // undefinedの時はキャンセル.
            this.editingSource = (o === null) ? [] : o;
          }
        });
    } else {
      this.dialog.selectOptions(this.editingSource)
        .then(o => {
          if (o !== undefined) {  // undefinedの時はキャンセル.
            this.editingSource = (o === null) ? [] : o;
          }
        });
    }
  }

  clear(): void {
    this.editingSource = [];
  }
}
